import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import { ProfileField } from '../../types/Profile';

export default function useProfileFields(): ProfileField[] {
  return useSelector((state: RootState) => state.user.fields);
}
